// Path: src\Components\RouterFiles\RouterFiles.jsx
import React from "react";
import { Route, Routes } from "react-router";
import { routesFrontend } from "./routes";
import HowToJoin from "../HowToJoin/HowToJoin";
import CreateProfile from "../Home/CreateProfile";
import HomePgae from "../Home/HomePgae";
import GameType from "../GameType/GameType";
import TournamentList from "../Tournament/TournamentList";
import TeamRegistration from "../Common/JoinViaCodeTeamRegistration";
import WorldOfEsports from "../WorldOfEports/WorldOfEsports";
import Profile from "../Profile/Profile";
import EditProfile from "../Profile/EditProfile";
import Rewards from "../Rewards/Rewards";
import More from "../More/More";
import TournamentDetails from "../Tournament/TournamentDetails/TournamentDetails";
import ContestList from "../Contest/ContestList";
import ContestDetails from "../Contest/ContestDetail";
import MyContestList from "../MyContest/MyContestList";
import TermsOfUse from "../Legality/TermsAndCondition";
import PrivacyPolicy from "../Legality/PrivacyPolicy";
import Leaderboard from "../../Components/LeaderBoard/Leaderboard";
import Vipoints from "../../Components/More/Points";
import MyRecentTransaction from "../Rewards/MyRecentTransaction";
import CustomerCare from "../CustomerCare/CustomerCare";
import CustomerCareTicketList from "../CustomerCare/CustomerCareTicketList";
import RaiseAComplaint from "../CustomerCare/RaiseAComplaint";
import TicketDetailPage from "../CustomerCare/TicketDetailPage";
import PrivateScrimDetail from "../PrivateScrims/PrivateScrimDetails/PrivateScrimDetailsTabs"
import PrivateScrimList from "../PrivateScrims/PrivateContestList"
import PrivateScrimSummary from "../PrivateScrims/CreateScrim/PrivateScrimSummary";
import HtmlFreeGames from "../HtmlFreeGames/HtmlFreeGames";
import HtmlFreeGameType from "../HtmlFreeGames/HtmlFreeGamesType";
import HtmlFreeGameByID from "../HtmlFreeGames/HtmlFreeGameByID";
import CreateScrim from "../PrivateScrims/CreateScrim/CreateScrim";
import EditScrim from "../PrivateScrims/CreateScrim/EditScrim"
import ManageScrim from "../PrivateScrims/ManageScrim/ManageScrim";
import Scrim from "../PrivateScrims/CreateScrim/Scrim";
import Subscription from "../Subscription/SubscriptionpackList";
import PopularVideos from "../WorldOfEports/PopularVideos";
import OpenPopularVideo from "../WorldOfEports/OpenPopularVideo";
import Esportdetail from "../WorldOfEports/EsportDetail";
import WorldOfEportsNews from "../WorldOfEports/EsportsNews"
import WorldOfEportsUserprofile from "../WorldOfEports/UserProfile"
import PayUStatus from "../PayU/PayUStatus"
import HtmlFreeGameDirectLink from "../HtmlFreeGames/HtmlFreeGameDirectLink"
import HowtoCreatescrim from "../PrivateScrims/CreateScrim/howtocreatescrim";
import UserProfile from "../UserProfile/Profile";
import UnderMaintaintance from "../Home/UnderMaintaintance";
const RouterFiles = () => {
  return (
    <Routes>
      <Route path={routesFrontend.undermaintaintance} element={<UnderMaintaintance />} />
      <Route path={routesFrontend.createProfile} element={<CreateProfile />} />
      <Route path={routesFrontend.howtojoin} element={<HowToJoin />} />
      <Route path={routesFrontend.home} element={<HomePgae />} />
      <Route path={routesFrontend.gameType} element={<GameType />} />
      <Route path={routesFrontend.htmlFreeGames} element={<HtmlFreeGames />} />
      <Route path={routesFrontend.htmlFreeGameType} element={<HtmlFreeGameType />} />
      <Route path={routesFrontend.htmlFreeGame} element={<HtmlFreeGameByID />} />
      <Route path={routesFrontend.worldOfEportsPopularVideos} element={<PopularVideos />} />
      <Route path={routesFrontend.worldOfEportsPopularVideo} element={<OpenPopularVideo />} />
      <Route path={routesFrontend.worldOfEportsNews} element={<WorldOfEportsNews />} />
      <Route path={routesFrontend.worldOfEportsUserprofile} element={<WorldOfEportsUserprofile />} />
      <Route path={routesFrontend.htmlFreeGameDirectLink} element={<HtmlFreeGameDirectLink />} />
      <Route path={routesFrontend.esportdetail} element={<Esportdetail />} />
      <Route
        path={routesFrontend.tournamentlist}
        element={<TournamentList />}
      />
      <Route
        path={routesFrontend.tournamentregistration}
        element={<TeamRegistration />}
      />
      <Route path={routesFrontend.worldOfEports} element={<WorldOfEsports />} />
      <Route path={routesFrontend.profile} element={<Profile />} />
      <Route path={routesFrontend.editprofile} element={<EditProfile />} />
      <Route path={routesFrontend.rewards} element={<Rewards />} />
      <Route path={routesFrontend.more} element={<More />} />
      <Route
        path={routesFrontend.tournamentdetails}
        element={<TournamentDetails />}
      />
      <Route path={routesFrontend.contestlist} element={<ContestList />} />
      <Route
        path={routesFrontend.contestdetails}
        element={<ContestDetails />}
      />
      <Route path={routesFrontend.mycontest} element={<MyContestList />} />
      <Route path={routesFrontend.termsofuse} element={<TermsOfUse />} />
      <Route path={routesFrontend.privacypolicy} element={<PrivacyPolicy />} />
      <Route path={routesFrontend.leaderboard} element={<Leaderboard />} />
      <Route path={routesFrontend.vipoints} element={<Vipoints />} />
      <Route
        path={routesFrontend.myRecentTransaction}
        element={<MyRecentTransaction />}
      />
      <Route path={routesFrontend.subscription} element={<Subscription />} />
      <Route path={routesFrontend.manageScrimDetail} element={<PrivateScrimDetail />} />
      <Route path={routesFrontend.howtoCreateScrim} element={<HowtoCreatescrim />} />


      {/* customer care */}
      <Route path={routesFrontend.customerCare} element={<CustomerCare />}>

        <Route path={""} element={<CustomerCareTicketList />} />
        <Route path={routesFrontend.raiseAComplaint} element={<RaiseAComplaint />} />
        <Route path={routesFrontend.ticketDetails} element={<TicketDetailPage />} />
      </Route>
      {/* private scrims */}
      <Route path={routesFrontend.privateScrim} element={<Scrim />}>
        <Route path={routesFrontend.manageScrim} element={<ManageScrim />} />
        <Route path={routesFrontend.privateScrimList} element={<PrivateScrimList />} />

        <Route path={routesFrontend.createScrim} element={<CreateScrim />} />
        <Route path={routesFrontend.editScrim} element={<CreateScrim />} />
        
        <Route path={routesFrontend.privateScrimSummary} element={<PrivateScrimSummary />} />
      </Route>
      <Route path={routesFrontend.userProfile} element={<UserProfile />} />
      <Route path={routesFrontend.paymentPayuStatus} element={<PayUStatus />} />
    </Routes>
  );
};

export default RouterFiles;
